"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVELOPMENT_INFO_FILENAME = exports.DEFAULT_LANGUAGE = void 0;
const DEVELOPMENT_INFO_FILENAME = exports.DEVELOPMENT_INFO_FILENAME = 'development-info.json';
const DEFAULT_LANGUAGE = exports.DEFAULT_LANGUAGE = 'en';
